/**
 * useScrollLock - Body scroll lock for modal/dialog/drawer overlays
 *
 * Re-entrant: 여러 오버레이가 동시에 열려도 마지막 하나가 닫힐 때까지
 * body scroll lock을 유지한다. 스크롤바 폭만큼 paddingRight 보상.
 *
 * @module core/hooks/useScrollLock
 */

import { useEffect } from "react";

let lockCount = 0;

function lock() {
  if (lockCount === 0) {
    // 스크롤바 너비 보상 (Windows/Linux 등 persistent scrollbar 환경)
    const scrollbarWidth =
      window.innerWidth - document.documentElement.clientWidth;

    document.body.style.overflow = "hidden";
    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    }
  }
  lockCount++;
}

function unlock() {
  lockCount = Math.max(0, lockCount - 1);
  if (lockCount === 0) {
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";
  }
}

/**
 * Body scroll lock hook.
 * `isLocked`가 true인 동안 body 스크롤을 잠근다.
 * 여러 컴포넌트에서 동시 사용해도 안전 (re-entrant counter).
 */
export function useScrollLock(isLocked: boolean) {
  useEffect(() => {
    if (!isLocked) return;

    lock();
    return () => unlock();
  }, [isLocked]);
}
